import React, { useEffect, useMemo, useState } from "react";
import { Button, Col, Form, Input, Label, Row } from "reactstrap";
import ToastAlert from "../../Components/Common/ToastAlert";
import { APIClient } from "../../helpers/api_helper";

const QuickEditInput = ({ toggleEditModal, isEditModalOpen, inputId, getInputList }) => {
    const api = useMemo(() => new APIClient(), []);
    const [item, setItem] = useState({ id: null, location: "", keyword: "", country: "TR" });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await api.get(`v1/inputs/${inputId}`);
                setItem(res);
            } catch (error) {
                ToastAlert(error, "error");
            }
        };
        if (inputId) fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputId]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await api.update("v1/inputs/", item);
            await getInputList();
            toggleEditModal();
            ToastAlert("Record updated successfully.", "success");
        } catch (error) {
            ToastAlert(error, "error");
        }
    };

    const handleModalClick = (e) => {
        if (e.target.classList.contains("modal")) {
            toggleEditModal();
        }
    };

    return (
        <React.Fragment>
            <div className={`modal fade ${isEditModalOpen ? "show" : ""}`} id="quickEditInput" tabIndex="-1" role="dialog" style={{ display: isEditModalOpen ? "block" : "none" }} onClick={handleModalClick}>
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header border-bottom-0">
                            <h5 className="modal-title">Edit Input</h5>
                            <button type="button" className="btn-close" onClick={toggleEditModal}></button>
                        </div>
                        <div className="modal-body">
                            <div className="row g-3">
                                <Form onSubmit={handleSubmit}>
                                    <Row className={"mb-3"}>
                                        <Col xxl={6}>
                                            <Label htmlFor="location" className="form-label">
                                                Location
                                            </Label>
                                            <Input type="text" id="location" className={"form-control"} value={item.location || ""} onChange={(e) => setItem({ ...item, location: e.target.value })} />
                                        </Col>

                                        <Col xxl={4}>
                                            <Label htmlFor="keyword" className="form-label">
                                                Keyword
                                            </Label>
                                            <Input type="text" id="keyword" className={"form-control"} value={item.keyword || ""} onChange={(e) => setItem({ ...item, keyword: e.target.value })} />
                                        </Col>
                                        <Col xxl={2}>
                                            <Label htmlFor="country" className="form-label">
                                                Country Code
                                            </Label>
                                            <Input type="text" id="country" className={"form-control"} value={item.country || "TR"} onChange={(e) => setItem({ ...item, country: e.target.value.toUpperCase() })} maxLength={2} />
                                        </Col>
                                    </Row>
                                    <Col lg={12}>
                                        <div className="hstack gap-2 justify-content-end">
                                            <Button type="button" className="btn btn-light" onClick={toggleEditModal}>
                                                Cancel
                                            </Button>
                                            <Button type="submit" className="btn btn-primary">
                                                Save
                                            </Button>
                                        </div>
                                    </Col>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isEditModalOpen && <div className="modal-backdrop fade show"></div>}
        </React.Fragment>
    );
};

export default QuickEditInput;


